var API_DOMAIN = "https://kalaicrackers.zentexus.in/api";

export default API_DOMAIN;
